define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaDocTypeDomain = void 0;
    class WaDocTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaDocTypeDomain.Agreement, value: "Agreement" },
                    { key: WaDocTypeDomain.Other, value: "Other" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaDocTypeDomain.Agreement] = 0;
                this.KeyIndex[WaDocTypeDomain.Other] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Agreement"] = 0;
                this.ValueIndex["Other"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaDocTypeDomain = WaDocTypeDomain;
    Object.defineProperty(WaDocTypeDomain, "Agreement", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaDocTypeDomain, "Other", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaDocTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
